module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.schema.label))]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    on: {
      "blur": _vm.blur
    },
    model: {
      value: (_vm.editorValue),
      callback: function($$v) {
        _vm.editorValue = $$v
      },
      expression: "editorValue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eefc5c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/blocks/HtmlControl.vue
// module id = 2621
// module chunks = 1